module.exports = __webpack_public_path__ + "img/dataTitle.1692d5c4.png";